import React from 'react';
import { PsPage } from '../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../i18n/I18nUtils';
import AttachmentFormCard from './AttachmentFormCard';
import { BreadcrumbsManagerInstance } from '../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../shared/breadcrumbs/Breadcrumbs';

export default class AttachmentScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.addBreadcrumb({
            ...Breadcrumbs.DOCUMENTS_ATTACHMENT,
            url: props.location.pathname,
        });

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_SUBIDA_DE_FICHEROS_A_MULTIPLES_DOCUMENTOS')} breadcrumbs={breadcrumbs}>
                <AttachmentFormCard/>
            </PsPage>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentScreen.jsx